import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { BrandMark } from "../components/party/GameVisuals";

export default function TvPage() {
  const [code, setCode] = useState("");
  const nav = useNavigate();
  async function go(e) {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    try { await api.get(`/public/tv/${c}`); nav(`/tv/m/${c}`); return; } catch { /* not a meeting code */ }
    try { await api.get(`/public/party/${c}`); nav(`/party-screen/${c}`); } catch { toast.error("We couldn't find that code"); }
  }
  return (
    <div className="min-h-screen bg-[#0b0b0b] text-white flex flex-col items-center justify-center gap-8 p-8" data-testid="tv-page">
      <BrandMark big />
      <p className="font-serif text-4xl sm:text-5xl font-light text-center">Show a meeting or game on this TV</p>
      <form onSubmit={go} className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
        <input autoFocus value={code} onChange={(e) => setCode(e.target.value)} maxLength={8} placeholder="TV CODE" className="bg-white/10 rounded-2xl px-4 py-5 text-3xl sm:text-4xl tracking-[0.3em] text-center uppercase outline-none w-full min-w-0" data-testid="tv-code-input" />
        <button className="btn-gold text-lg px-8" data-testid="tv-go-btn">Show</button>
      </form>
      <p className="text-white/50 text-center">Meeting codes are under the Cast button in any video meeting. Game codes are on every guest's phone.</p>
    </div>
  );
}
